module.exports = __webpack_public_path__ + "img/江苏大学.0921366d.png";